import Model, { attr, hasMany } from '@ember-data/model';

export default class DocumentRequestContactInfoConnectionModel extends Model {
  @hasMany('insurance-card', { async: false, inverse: 'connection' }) insuranceCards;

  @attr() insuranceCardFrontId;
  @attr() insuranceCardBackId;

  @hasMany('photo-id', { async: false, inverse: 'connection' }) photoIds;

  @attr() photoIdFrontId;
  @attr() photoIdBackId;
}
